// action type for templates action
export const SET_TEMPLATES_LIST = "SET_TEMPLATES_LIST";
export const ADD_TEMPLATE = "ADD_TEMPLATE";
export const UPDATE_TEMPLATE = "UPDATE_TEMPLATE";
export const DELETE_TEMPLATE = "DELETE_TEMPLATE";
